import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TableService } from 'src/app/core/services/table.service';
import { TableColumn } from 'src/app/core/models/table.model';
import { Breakpoint } from 'src/app/core/services/responsive.service';
import { RowItem } from 'src/app/core/models/item.model';
import { NavigationService } from '../../../../../src/app/core/services/navigation.service';
import { IspvisionService, VisionWs } from '../../../../../src/app/core/services/ispvision.service';
@Component({
    selector: 'downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.less'],
})
export class DownloadsComponent implements OnInit {
    constructor(
        public tableService: TableService,
        public navigation: NavigationService,
        private route: ActivatedRoute,
        public visionWs: IspvisionService
    ) {
        this.route.data.subscribe((data) => {
            this.visionWs.setFormPartitioning(data['type']);
        });
    }

    public downloads: { href: string; title: string }[] = [];

    async ngOnInit(): Promise<void> {
        this.downloads = await this.visionWs.getDownloads();
        this.tableService.register(
            {
                paginator: true,
                breakpoint: { column: [Breakpoint.MD], row: [Breakpoint.MD] },
            },
            this.mapColumns.bind(this),
            this.mapDownloadsToTable.bind(this),
            this.downloads
        );
    }

    get hasDownloads(): boolean {
        return this.downloads.length > 0;
    }

    private mapColumns(): TableColumn[] {
        return [
            {
                item: { type: 'text', text: 'Titel' },
                sortOn: 'title',
                width: 75,
                breakpoint: {
                    breakpoint: Breakpoint.MD,
                    widthUntil: 40,
                },
            },
            {
                item: { type: 'text', text: 'itemUser.actions' },
                position: 'center',
                width: 25,
                breakpoint: {
                    breakpoint: Breakpoint.MD,
                    state: 'after',
                },
            },
        ];
    }

    /**
     * Map invoices to table format
     *
     * @author    Arjan Koemans <arjan@safira.nl>
     */
    private mapDownloadsToTable(download: { title: string; href: string }): RowItem {
        return {
            type: 'row',
            expandable: {
                breakpoint: Breakpoint.MD,
                colspan: 2,
                gap: 10,
                closedHeight: 16.8,
                openHeight: 83.6,
            },
            items: [
                {
                    type: 'text',
                    text: download.title,
                    expansion: 'hidden',
                },
                {
                    type: 'group',
                    position: 'center',
                    expansion: 'expandable',
                    items: [
                        {
                            type: 'text',
                            icon: 'cloud-arrow-down',
                            iconHover: true,
                            iconBorder: true,
                            action: {
                                type: 'anchor',
                                route: '/api/media/files/' + download.href,
                                target: 'blank',
                                download: true,
                            },
                            title: 'global_edit',
                        },
                    ],
                },
            ],
        };
    }
}
